import { Box, Card, CardContent, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";

function CardCounter({ cards }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));

    return (
        <Stack
            direction={isMobile ? "column" : "row"}
            spacing={2}
            justifyContent="flex-start"
            alignItems={isMobile ? "stretch" : "center"}
            flexWrap="wrap"
            marginRight={2}
        >
            {cards.map((card, i) => (
                <Card
                    key={i}
                    sx={{
                        flex: "1 1",
                        minWidth: 120,
                        borderRadius: 3,
                        boxShadow: "0px 2px 6px rgba(0,0,0,0.08), 0px 1px 3px rgba(0,0,0,0.04)",
                        p: 2,
                        backgroundColor: "background.main",
                    }}
                >
                    <Stack direction="row" justifyContent="space-between">
                        <Typography variant="title">
                            {card.value}
                        </Typography>

                    </Stack>
                    <CardContent 
                    sx={{ 
                        p: 0, 
                        textAlign: "right",
                         '&:last-child': {
                            pb: 0
                        }
                     }}>
                        <Typography variant="body" color="#18302194" sx={{ mt: 1, p:0 }}>
                            {card.label}
                        </Typography>
                    </CardContent>
                </Card>
            ))}
        </Stack>
    );
}

export default CardCounter;